<template>
    <div class="search-filter">
        <input
            ref="input"
            v-model.trim="searchText"
            type="text"
            placeholder="Search..."
            @keypress.enter="$emit('keypress-enter')"
        />

        <span
            v-if="searchText.length > 0"
            class="fa-solid fa-times clear-search"
            title="Clear search"
            @click="searchText = ''"
        />

        <span v-else class="fa-solid fa-search" title="Search" />
    </div>
</template>

<script>
export default {
    props: {
        value: String,
    },
    data() {
        return {
            searchText: this.value,
        };
    },
    watch: {
        searchText() {
            return this.$emit('input', this.searchText.toLowerCase());
        },
    },
    methods: {
        focus() {
            $(this.$refs.input).focus();
        },
        clear() {
            this.searchText = '';
        },
    },
};
</script>
